import React from 'react';
import { useLocation } from 'react-router-dom';

import { Button, FeaturedIcon } from '@myhealth-raccoon/components';

import { ContentContainer } from 'src/components/ContentContainer';
import { StickyBottomBar } from 'src/components/StickyBottomBar';
import { useClinicSelector } from 'src/hooks/useAsyncSelector';
import { useExit } from 'src/hooks/useExit';

export function ApptTypeRequiresF2F() {
    const location = useLocation();
    const { lastF2FVisitInMonths } = location.state || {}; // Destructure passed state
    const { data: clinic } = useClinicSelector();
    const exit = useExit();

    return (
        <>
            <ContentContainer className="flex-1 space-y-6 text-center lg:flex-none">
                <FeaturedIcon size="lg" color="error" className="mx-auto mb-8" />
                <h1 className="text-2xl font-medium text-gray-900">Appointment type unavailable</h1>
                <p>
                    This Appointment Type is only available to patients who have had an in-clinic consultation in the
                    past {lastF2FVisitInMonths} months.
                </p>
                <p>
                    Please book an in-clinic appointment instead, or call our reception
                    {clinic?.phoneNumber ? ` on ` : ''}{' '}
                    <a className="text-primary" href={`tel:${clinic?.phoneNumber}`}>
                        {clinic?.phoneNumber}{' '}
                    </a>
                    for further assistance.
                </p>
            </ContentContainer>
            <StickyBottomBar>
                <Button className="w-full" color="gray" onClick={() => exit()}>
                    Exit
                </Button>
            </StickyBottomBar>
        </>
    );
}
